import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faCrosshairs,
    faChevronDown
}
from "@fortawesome/free-solid-svg-icons";


export default function AiInsightCard(
{
    insight,
    expanded,
    onToggle,
    onLocate
})
{

    //--------------------------------------------------------
    // Severity colour
    //--------------------------------------------------------

    const colour =

        insight.severity === "CRITICAL"

            ? "#d62828"

        : insight.severity === "MEDIUM"

            ? "#f39c12"

            : "#2ecc71";


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div

            onClick={onToggle}

            style={{

                marginBottom:
                    "8px",

                padding:
                    "10px 16px",

                borderRadius:
                    "0px",

                background:
                    "linear-gradient(" +
                    "180deg, " +
                    "rgba(255,255,255,.055) 0%, " +
                    "rgba(255,255,255,.025) 100%" +
                    ")",

                border:
                    "1px solid rgba(255,255,255,.08)",

                overflow:
                    "hidden",

                cursor:
                    "pointer",

                transition:
                    "all .25s ease"
            }}

        >

            {/* ------------------------------------------------
                Main row
                ------------------------------------------------ */}

            <div

                style={{

                    display:
                        "flex",

                    alignItems:
                        "center"
                }}

            >

                {/* --------------------------------------------
                    Severity indicator
                    -------------------------------------------- */}

                <div

                    style={{

                        width:
                            "24px",

                        height:
                            "24px",

                        borderRadius:
                            "50%",

                        background:
                            colour,

                        color:
                            "white",

                        fontWeight:
                            700,

                        fontSize:
                            "17px",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        flexShrink:
                            0
                    }}

                >

                    !

                </div>


                {/* --------------------------------------------
                    Insight title
                    -------------------------------------------- */}

                <div

                    style={{

                        flex:
                            1,

                        marginLeft:
                            "12px"
                    }}

                >

                    <div

                        style={{

                            color:
                                "white",

                            fontWeight:
                                600,

                            fontSize:
                                "14px",

                            lineHeight:
                                "18px"
                        }}

                    >

                        {insight.title}

                    </div>

                </div>


                {/* --------------------------------------------
                    Actions
                    -------------------------------------------- */}

                <div

                    style={{

                        display:
                            "flex",

                        alignItems:
                            "center",

                        gap:
                            "10px"
                    }}

                >

                    {/* ----------------------------------------
                        Locate
                        ---------------------------------------- */}

                    <div

                        onClick={(e) =>
                        {

                            e.stopPropagation();

                            onLocate();

                        }}

                        style={{

                            width:
                                "28px",

                            height:
                                "28px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                "linear-gradient(" +
                                "180deg, " +
                                "#42bff5 0%, " +
                                "#159bd7 100%" +
                                ")",

                            color:
                                "white",

                            cursor:
                                "pointer",

                            boxShadow:
                                "0 4px 10px rgba(21,155,215,.30)",

                            transition:
                                ".2s"
                        }}

                    >

                        <FontAwesomeIcon
                            icon={faCrosshairs}
                        />

                    </div>


                    {/* ----------------------------------------
                        Expand / collapse
                        ---------------------------------------- */}

                    <FontAwesomeIcon

                        icon={faChevronDown}

                        style={{

                            color:

                                expanded

                                    ? "#42bff5"

                                    : "rgba(255,255,255,.65)",

                            fontSize:
                                "13px",

                            transform:

                                expanded

                                    ? "rotate(180deg)"

                                    : "rotate(0deg)",

                            transition:
                                "transform .35s ease"
                        }}

                    />

                </div>

            </div>


            {/* ------------------------------------------------
                Expanded description
                ------------------------------------------------ */}

            <div

                style={{

                    maxHeight:

                        expanded

                            ? "160px"

                            : "0px",

                    opacity:

                        expanded

                            ? 1

                            : 0,

                    overflow:
                        "hidden",

                    transition:
                        "max-height .35s ease, " +
                        "opacity .25s ease, " +
                        "margin-top .35s ease",

                    marginTop:

                        expanded

                            ? "12px"

                            : "0px"
                }}

            >

                <div

                    style={{

                        color:
                            "rgba(255,255,255,.78)",

                        fontSize:
                            "13px",

                        lineHeight:
                            "19px"
                    }}

                >

                    {insight.description}

                </div>

            </div>

        </div>

    );

}